import { render, staticRenderFns } from "./OverviewOrder.vue?vue&type=template&id=c493fe70&scoped=true&"
import script from "./OverviewOrder.vue?vue&type=script&lang=js&"
export * from "./OverviewOrder.vue?vue&type=script&lang=js&"
import style0 from "./OverviewOrder.vue?vue&type=style&index=0&id=c493fe70&prod&lang=css&"
import style1 from "./OverviewOrder.vue?vue&type=style&index=1&id=c493fe70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493fe70",
  null
  
)

export default component.exports